import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useFundingCurrency } from './currency-react.js';
import { convertFundingFiat, fundingRateIsCurrent } from './fx.js';
/** A prepared operation owns its currency. Preference sync cannot relabel an active payment. */
export function useCheckoutCurrency(options, progress, operation) {
  const $ = _c(18);
  let t0;
  if ($[0] !== options.currency || $[1] !== options.decimals || $[2] !== progress.amountCurrency || $[3] !== progress.amountDecimals || $[4] !== progress.amountUnits) {
    t0 = () => ({
      currency: progress.amountCurrency ?? options.currency,
      decimals: progress.amountDecimals ?? options.decimals,
      units: progress.amountUnits ?? undefined
    });
    $[0] = options.currency;
    $[1] = options.decimals;
    $[2] = progress.amountCurrency;
    $[3] = progress.amountDecimals;
    $[4] = progress.amountUnits;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const [draft, setDraft] = useState(t0);
  let current;
  let unavailable;
  if ($[6] !== draft || $[7] !== operation || $[8] !== options.currency || $[9] !== options.decimals || $[10] !== options.fundingFx) {
    const desired = {
      currency: options.currency,
      decimals: options.decimals
    };
    const differs = draft.currency !== desired.currency || draft.decimals !== desired.decimals;
    current = draft;
    unavailable = false;
    if (!operation && differs) {
      const converted = convertDraft(draft, desired, options.fundingFx);
      if (converted) {
        current = converted;
        setDraft(converted);
      } else {
        unavailable = true;
      }
    }
    $[6] = draft;
    $[7] = operation;
    $[8] = options.currency;
    $[9] = options.decimals;
    $[10] = options.fundingFx;
    $[11] = current;
    $[12] = unavailable;
  } else {
    current = $[11];
    unavailable = $[12];
  }
  const currency = operation?.fiatCurrency ?? current.currency;
  const decimals = operation?.fiatDecimals ?? current.decimals;
  const fx = unavailable ? null : operation?.receiveTarget?.fx ?? options.fundingFx;
  useFundingCurrency(currency, fx);
  let t1;
  if ($[13] !== currency || $[14] !== current.units || $[15] !== decimals || $[16] !== fx) {
    t1 = {
      currency,
      decimals,
      fx,
      units: current.units,
      setUnits(update) {
        setDraft(previous => ({
          currency,
          decimals,
          units: typeof update === "function" ? update(previous.units) : update
        }));
      }
    };
    $[13] = currency;
    $[14] = current.units;
    $[15] = decimals;
    $[16] = fx;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  return t1;
}
function convertDraft(draft, desired, fx) {
  if (!draft.units) return {
    ...desired,
    units: draft.units
  };
  if (!fx || !fundingRateIsCurrent(fx, Date.now())) return null;
  try {
    return {
      ...desired,
      units: convertFundingFiat(draft.units, draft.currency, draft.decimals, desired.currency, desired.decimals, fx, 'nearest')
    };
  } catch {
    // Keep the original denomination and draft when either valuation pair is unavailable.
    return null;
  }
}